import { useNavigate } from 'react-router-dom';
import HousekeepingModal from './Housekeeping';

export default function HousekeepingPage() {
  var navigate = useNavigate();
  return (
    <HousekeepingModal onClose={function() { navigate(-1); }} />
  );
}